const firebaseConfig = {
  apiKey: "AIzaSyDzIuPNyzWXbNR-UvCGor83v3axPOjCrHc",
  authDomain: "kenakata-auth.firebaseapp.com",
  projectId: "kenakata-auth",
  storageBucket: "kenakata-auth.appspot.com",
  messagingSenderId: "818751804005",
  appId: "1:818751804005:web:9f74ded36e0fb55e042c8c",
};

export default firebaseConfig;
